import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const duplicateTaskTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/task_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

interface DuplicateTaskTemplateInput {
  uuid: string;
  name: string;
}

export function useDuplicateTaskTemplate(onSuccessCallback: (newUuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateTaskTemplateInput) => duplicateTaskTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTaskTemplates] });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the task template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
